export const SET_ERRORS = 'SET_ERRORS';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_SHOW_LOADING = 'SET_SHOW_LOADING';
export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION';
export const SET_SUITE_VERSION = 'SET_SUITE_VERSION';
